import apiRequest from './apiRequest';

export default async function postServiceAccount(serviceName?: string) {
  return await apiRequest<{ apiKey: string; serviceID: string }>(
    'user',
    '/serviceAccounts',
    {
      method: 'POST',
      body: JSON.stringify({ serviceName }),
    },
  );
}
